import { create } from "zustand";

// The access token lives in memory and nowhere else. Not localStorage, not a
// readable cookie: with payroll behind this login, an XSS payload should get
// 15 minutes of access, never a durable credential it can exfiltrate.
// It is lost on refresh by design -- the httpOnly refresh cookie restores the
// session silently on boot.
export const useAuthStore = create((set, get) => ({
  accessToken: null,
  user: null,
  permissions: [],
  isBootstrapping: true,

  setSession: ({ accessToken, user, permissions }) =>
    set({ accessToken, user, permissions: permissions || [], isBootstrapping: false }),

  setAccessToken: (accessToken) => set({ accessToken }),

  setUser: (user) => set({ user }),

  clear: () => set({ accessToken: null, user: null, permissions: [], isBootstrapping: false }),

  finishBootstrap: () => set({ isBootstrapping: false }),

  isAuthenticated: () => Boolean(get().accessToken),
}));

// Non-hook accessor for the axios interceptor, which lives outside React.
export const authStore = {
  get: () => useAuthStore.getState(),
  setAccessToken: (t) => useAuthStore.getState().setAccessToken(t),
  clear: () => useAuthStore.getState().clear(),
};
